import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import "./closeButton.scss";

import CloseButtonSvg from "../../../images/window-close-icon-20.svg?react";

type Props = {
  testId?: string;
  id?: string;
  className?: string;
  onClick?: () => void;
  inverted?: boolean;
};

function CloseButton(props: Props) {
  const { onClick, className, id, inverted, testId } = props;
  return (
    <div
      id={id}
      className={cn("close-icon-container", className, { inverted })}
      data-testid={testId ?? "close-button"}
      onClick={onClick}
    >
      <CloseButtonSvg />
    </div>
  );
}

CloseButton.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  inverted: PropTypes.bool,
};

export default CloseButton;
